import { FluentThemeProvider } from './theme/fluent/Provider';
import { SnackbarProvider, WorkspaceChromeProvider, ChatPanelStateProvider } from './providers';
import { QueryProvider } from './providers/QueryProvider';
import { AppConfigProvider } from './features/app-config';
import { ChatProvider } from './features/chat';
import { AppRouter } from './router/AppRouter';

function App() {
  return (
    <QueryProvider>
      <FluentThemeProvider>
        <WorkspaceChromeProvider>
          <ChatPanelStateProvider>
            <SnackbarProvider>
              <AppConfigProvider>
                <ChatProvider>
                  <AppRouter />
                </ChatProvider>
              </AppConfigProvider>
            </SnackbarProvider>
          </ChatPanelStateProvider>
        </WorkspaceChromeProvider>
      </FluentThemeProvider>
    </QueryProvider>
  );
}

export default App;
